import { withInstall } from '@vuemap/vue-amap-util'
import RoadNet from './RoadNet.vue'

export const ElAmapLayerRoadNet = withInstall(RoadNet)
export default ElAmapLayerRoadNet
